module.exports = __webpack_public_path__ + "static/media/more-button.243b50ee.svg";